import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { ShopService } from '@services/shop-service/shop.service';
import { AllocatedRegimen } from '../../../app-constant-types';

@Component({
  selector: 'app-buy-complete-kit-banner',
  standalone: true,
  imports: [ButtonCtaComponent],
  templateUrl: './buy-complete-kit-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyCompleteKitBannerComponent {
  private readonly shopService = inject(ShopService);

  regimen = input<AllocatedRegimen | null>(null);
  buyKit = output<AllocatedRegimen>();

  discount = computed(() => this.shopService.getDiscountPercent(this.regimen()));

  onBuyKit(): void {
    const reg = this.regimen();
    if (!reg) return;
    this.buyKit.emit(reg);
  }
}
